const API_BASE_URL = 'https://serv.keni.rakopssolutions.com/api';

export default API_BASE_URL;
